// extracted by mini-css-extract-plugin
export default {"copyButton":"copyIconInput_copyButton__z4ZYO","copyButton__button":"copyIconInput_copyButton__button__PbkZ4"};